import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
  ChangeDetectionStrategy, OnChanges, SimpleChanges
} from '@angular/core';
import { AppState } from '../../../../app.reducers';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkspaceUserProperty } from '../../../shared/models/workspace-user-property';
import { LoadPropertyRequest } from '../../../property/shared/models';
import { ModalComponent } from '../../../shared/components/modal';
import {
  LoadSelectedPropertyAction,
} from '../../../property/property-store/property.actions';
import { SubSink } from 'subsink';
import { PropertySearchResult, UserProfile } from '../../models';

@Component({
  selector: 'sp-user-property-list',
  templateUrl: './user-property-list.component.html',
  styleUrls: ['./user-property-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UserPropertyListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() propertySearchResult: PropertySearchResult;
  @Input() hasProperties: boolean;
  @Input() isLogin: boolean;
  @Input() selectedPropertyId: string;
  @Input() userProfile: UserProfile;
  @Output() showDialog: EventEmitter<void> = new EventEmitter<void>();
  @Output() pageChanged = new EventEmitter<number>();
  @Output() archive = new EventEmitter<string>();

  isWorkspaceRedirect = false;
  deleteProperty: WorkspaceUserProperty;
  private subs = new SubSink();

  @ViewChild(ModalComponent, { static: true }) public archiveProperty: ModalComponent;

  constructor(private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.subs.sink = this.route.params
      .subscribe(params => {
        this.isWorkspaceRedirect = params['isWorkspace'] === 'true';
      });

    if (this.hasProperties === false) {
      this.showDialog.next();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    // During login, isLogin will be true and selectedPropertyId will be updated to contain a value...
    // If that happens, then we know the user is on this page because they just logged in and have
    // a previously selected propertyId, so redirect them to the dashboard.
    if (changes['selectedPropertyId'] && this.selectedPropertyId && this.isLogin) {
      this.router.navigate(['useraccount/properties/dashboard']);
    }

    if (changes['propertySearchResult'] && this.propertySearchResult?.propertiesPaged?.data?.length > 0) {
      this.propertySearchResult.propertiesPaged.data = this.propertySearchResult.propertiesPaged.data.filter(a => a.propertyIsActive === true);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  hasResults(): boolean {
    return this.propertySearchResult?.propertiesPaged?.data?.length > 0;
  }

  delete(property: any) {
    this.deleteProperty = property;
    this.archiveProperty.show();
  }

  onArchive() {
    if (this.deleteProperty) {
      this.archive.emit(this.deleteProperty.propertyId);
    }
  }

  onEditDetails(property: any) {
    this.selectPropertyAndNavigate(property, 'useraccount/properties/details/' + property.propertyId);
  }

  onViewDashboard(property: any) {
    this.selectPropertyAndNavigate(property, 'useraccount/properties/dashboard');
  }

  onDxPageChanged(event) {
    if (event.name === 'pageIndex') {
      this.pageChanged.emit(event.value);
    }
  }

  private selectPropertyAndNavigate(property: WorkspaceUserProperty, url: string) {
    this.store.dispatch(new LoadSelectedPropertyAction(new LoadPropertyRequest(property.propertyId, true, url)));
  }
}
